import { Divider } from 'antd'
import OrderDetailModalHeader from './blocks/OrderDetailModalHeader'
import OrderDetailModalFooter from './blocks/OrderDetailModalFooter'
import { OnCloseModalType } from 'pages/Orders/types'
import OrderDetailModalMain from './blocks/OrderDetailUserInfo'

const OrderDetailsModal: React.FC<OnCloseModalType> = ({ onCloseModal }) => {
  return (
    <>
      <OrderDetailModalHeader />
      <Divider type="horizontal" />
      <OrderDetailModalMain />
      <OrderDetailModalFooter onCloseModal={onCloseModal} />
    </>
  )
}

export default OrderDetailsModal
